"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TimeObject_1 = require("./TimeObject");
class AdAnalyticsVideoIndexKeyFrame {
    constructor({ thumbnailImageUrl, start, end }) {
        this.toJSON = () => ({
            thumbnailImageUrl: this.thumbnailImageUrl,
            start: this.start,
            end: this.end,
        });
        this.thumbnailImageUrl = thumbnailImageUrl;
        this.start = start;
        this.end = end;
    }
}
AdAnalyticsVideoIndexKeyFrame.fromJSON = (json) => {
    const { thumbnailImageUrl, start, end } = Object.assign({}, json);
    if (typeof thumbnailImageUrl !== 'string')
        throw new Error('.thumbnailImageUrl must be a string');
    const _start = TimeObject_1.default.fromJSON(start);
    const _end = TimeObject_1.default.fromJSON(end);
    return new AdAnalyticsVideoIndexKeyFrame({
        thumbnailImageUrl,
        start: _start,
        end: _end,
    });
};
exports.default = AdAnalyticsVideoIndexKeyFrame;
